import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Container = styled.div`
  position: ${(props) => (props.isfixed ? 'fixed' : 'relative')};
  top: 0;
  z-index: 100;
  width: 100%;
`;

export const DivContainer = styled.div`
  /* position: ${(props) => (props.isfixed ? 'fixed' : 'relative')};
  top: 0;
  z-index: 100; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0px;
  padding: 0rem 5rem;
  background-color: ${(props) => props.backgroundcolor};
  box-shadow: rgba(50, 50, 93, 0.25) 0px 3px 6px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;

  .logo {
    width: ${(props) => 180 * props.fontsizemultiplier};
    height: ${(props) => 50 * props.fontsizemultiplier};
  }

  @media (max-width: 1023px) {
    position: fixed;
    padding: 0rem 0rem;

    .logo {
      width: 120;
      height: 33.2;
    }

    .links {
      position: absolute;
      top: -70rem;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }

    .links.active {
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      display: block;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      background-color: ${(props) => props.backgroundcolor};
    }

    .spinner {
      padding: 2rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .menu {
    margin-right: 1rem;
    border-right: 1px solid #dfdedc;
    cursor: pointer;

    @media (min-width: 1023px) {
      display: none;
    }
  }
`;

export const Ul = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1023px) {
    display: block;
    width: 100%;
    padding: 2rem 3rem 1rem 3rem;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 3px 6px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;

    .secondary-navbar {
      padding: 1rem;
      margin: 1rem 2rem 1rem 0rem;
      background-color: ${(props) => props.backgroundcolor};
    }

    .accesibilidad {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 20px;
      overflow: hidden;

      p {
        margin: auto 0;
        min-height: 3.6rem;
        padding: 0.5rem 1rem;
        background-color: ${(props) => props.btnbackground};
        color: ${(props) => props.active?.color_base_blanco};
        font-size: 16;
        font-weight: 700;
      }

      .button {
        border: none;
        padding: 0 1rem;
        background-color: ${(props) => props.active?.color_base_blanco};
        font-size: 16;
        font-weight: 700;

        &:active {
          background-color: ${(props) => props.btnbackground};
          color: ${(props) => props.theme.blanco};
        }
      }
    }
  }

  @media (min-width: 1023px) {
    .secondary-navbar {
      display: none;
    }
  }
`;

export const StyledNavLink = styled(NavLink)`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 2rem;
  padding-right: ${(props) => (props.name === 'SEDES' ? '2rem' : '0rem')};
  padding-left: ${(props) => (props.name === 'SEDES' ? '1rem' : '0rem')};
  border-left: ${(props) =>
    props.name === 'SEDES' ? '1px solid #dfdedc' : 'none'};
  border-right: ${(props) =>
    props.name === 'SEDES' ? '1px solid #dfdedc' : 'none'};
  font-size: ${(props) => 16 * props.fontsizemultiplier};
  font-weight: ${(props) => (props.name === 'SEDES' ? 800 : 600)};
  color: ${(props) => props.color};

  &:hover {
    color: ${(props) => props.color};
  }

  &:after {
    display: block;
    position: absolute;
    left: 0;
    bottom: -0.8rem;
    width: 0;
    height: 0.2rem;
    background: ${(props) => props.color};
    content: '';
    transition: width 0.2s;
  }

  &:hover:after {
    width: 100%;
  }

  @media (max-width: 1023px) {
    margin-bottom: 2rem;
    padding: 0;
    border-right: 0rem;
    border-left: 0rem;
    border-bottom: ${(props) =>
      props.name === 'SEDES' ? '1px solid #dfdedc' : 'none'};
  }
`;

// export const LupaContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: ${(props) => 40 * props.fontsizemultiplier};
//   height: ${(props) => 40 * props.fontsizemultiplier};
//   border-radius: 50%;
//   margin-right: 2rem;
//   cursor: pointer;
//   background-color: #05aaaa;

//   &:active {
//     opacity: 0.5;
//   }

//   img {
//     width: ${(props) => 30 * props.fontsizemultiplier};
//   }

//   @media (max-width: 1023px) {
//     width: 40;
//     height: 40;

//     img {
//       width: 30;
//     }
//   }
// `;

export const ProgramarCita = styled.div`
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  cursor: pointer;
  background-color: ${(props) => props.backgroundcolor};

  &:active {
    filter: brightness(1.1);
  }

  p {
    font-size: ${(props) => 14 * props.fontSizeMultiplier};
    font-weight: 700;
    margin-left: 1rem;
    color: ${(props) => props.color};
    text-transform: uppercase;
  }

  @media (max-width: 1023px) {
    p {
      display: none;
    }
  }
`;

// Navbar Secundario
export const AccContainer = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 1.5rem;
  margin-left: 2rem;
  overflow: hidden;
`;

export const StyledLink = styled(NavLink)`
  width: 100%;
  font-size: 14;
  text-emphasis: none;
  text-decoration: none;
  text-align: left;
  padding: 1.5rem 0;
  border-top: 1px solid #fff;
  color: #fff;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 1rem;
`;

export const SocialMedia = styled.div`
  display: flex;
  border-top: 1px solid #fff;
  padding: 1.5rem 0 1rem 0;

  .twitter {
    padding-right: 2rem;
    border-right: 1px solid #fff;
  }

  .facebook {
    padding-left: 2rem;
  }
`;

export const ServiceContainer = styled.div`
  position: absolute;
  top: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.backgroundcolor};

  .item-container {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
    width: 100%;
    margin-bottom: 1rem;
    padding: 2rem;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.itembackground};
    padding: 2rem;
    border-radius: 2rem;
    cursor: pointer;
    /* transition: 0.1s linear; */

    p {
      text-align: center;
      font-size: ${(props) => 20 * props.fontsizemultiplier};
      font-weight: 700;
      color: ${(props) => props.color};
    }

    &:hover {
      p {
        filter: brightness(1.2);
      }
    }
  }

  @media (max-width: 1023px) {
    display: none;
  }
`;
